export default "__VITE_ASSET__BnCoxQxR__"